function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const Clear = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M11.4 13.06l4.596 4.597a.749.749 0 1 0 1.06-1.06l-4.595-4.597 4.596-4.596a.749.749 0 1 0-1.06-1.06l-4.597 4.595-4.596-4.596a.749.749 0 1 0-1.06 1.06l4.595 4.597-4.596 4.596a.749.749 0 1 0 1.06 1.06l4.597-4.595z"
}, " "));

Clear.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Clear;